import React from 'react';

class TabContent extends React.Component {
  render() {
    const activeTabClass = 'tab-pane active';
    const nonActiveTabClass = 'tab-pane';
    const props = this.props;
    const _tabs = props.tabs;
    const tabsContentHtml = _tabs.map((tab, index) => (
      <div key={'contentIndex' + index} className={index === this.props.selectedTabIndex ? activeTabClass : nonActiveTabClass} id={tab.id}>
        {this.props.children[index]}
      </div>
      ));
    return <div className="tab-content">{tabsContentHtml}</div>;
  }
}

export default TabContent;
